export default __webpack_public_path__ + "static/CCSignLanguage-724933811e72816b42eb4dddaa9d827e.ttf";